import { useState } from 'react';
import { useAccountingCustomSegments, useAccountingOptions } from '../../../../hooks';
import {customSegmentLevelTypeConstants} from '../../../../constants';

export const useBillsTabState = (onFilter, initialSearch = '') => {
  const [query, setQuery] = useState({ search: initialSearch });

  const {
    departmentOptions,
    listItemOptions,
    locationOptions,
    taxCodeOptions
  } = useAccountingOptions();

  const customSegments = useAccountingCustomSegments({levelsPropertyName: customSegmentLevelTypeConstants.VENDOR_BILL});

  const handleOnFilter = (filterParams) => {
    setQuery(prev => ({ ...prev, ...filterParams }));
    onFilter?.(filterParams);
  };

  return {
    customSegments,
    departmentOptions,
    listItemOptions,
    locationOptions,
    taxCodeOptions,
    handleOnFilter,
    setQuery,
    query,
  };
}

